/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import tokens, { ColorType } from '@veneer/tokens';
import colors from '../scss/colors.module.scss';

// @deprecated
export interface ColorToken {
  inkTertiary: string;
  inkPrimary: string;
  inkSubtle: string;
  inkDisabled: string;
  inkBrandDisabled: string;
  inkBrandPrimary: string;
  inkSecondary: string;
  inkAlwaysLight: string;
  inkPositive: string;
  inkWarning: string;
  inkNegative: string;
  inkNegativeIntense: string;
  inkNegativeDisabled: string;
  inkInverse: string;
  inkSupport: string;
  inkNeutral: string;
  inkSentimentInfo: string;
  inkSentimentNegative: string;
  inkSentimentWarning: string;
  inkSentimentPositive: string;

  interfaceBackgroundPrimary: string;
  interfaceSurfaceBase: string;
  interfaceSurfaceElevataed: string;
  interfaceScrimBase: string;
  interfaceSurfaceWarningBase: string;
  interfaceStrokeBrandBase: string;
  interfaceStrokeStrong: string;
  interfaceSurfaceNegativeBase: string;
  interfaceStrokeBase: string;
  interfaceSurfaceSubtle: string;
  interfaceBackgroundBlur: string;

  interactivePrimaryMinimalHover: string;
  interactivePrimaryMinimalPressed: string;
  interactivePrimaryBase: string;
  interactivePrimaryHover: string;
  interactivePrimaryPressed: string;
  interactiveFocus: string;
  interactiveTertiaryHover: string;
  interactiveNegativeBase: string;
  interactiveNegativeHover: string;
  interactiveNegativePressed: string;
  interactiveNegativeDisabled: string;
  interactiveNegativeMinimalHover: string;
  interactiveInputPressed: string;
  interactiveInputHover: string;
  interactiveSecondaryMinimalHover: string;
  interactiveSecondaryMinimalPressed: string;
  interactiveSecondaryBase: string;
  interactiveSecondaryHover: string;
  interactiveSecondaryPressed: string;
  interactiveNavigationBase: string;
  interactiveNavigationHover: string;
  interactiveNavigationPressed: string;
  interactivePrimaryDisabled: string;
  interactiveSecondaryDisabled: string;
  interactiveNavigationDisabled: string;
  interactiveLinkBase: string;
  interactiveInputMinimalHover: string;
  interactiveInputBase: string;
  interactiveInputBaseSelected: string;
  interactiveInputBaseHover: string;
  interactiveInputBasePressed: string;

  neutral2: string;
  royalBlue0: string;
  hpBlue: string;
  backgroundDisabled: string;
  black: string;
  dividerSubtle: string;
  dividerBase: string;
  pageBackground: string;
  listHeadline: string;
  sliderThumbHover: string;
  inputText: string;
  error: string;
  deviceControlBackground: string;
  iconBackground: string;
  surfaceSupportBase: string;
  badgeBackground: string;
  urgentNotification: string;
  urgentNotificationBackground: string;
  warningNotificationBackground: string;
  supportNotificationBackground: string;
  informativeNotificationBackground: string;
  focusState: string;
  backgroundKeyDark: string;
  gridLine: string;
  dividerColor: string;
}

export type Color = ColorToken & ColorType;

/**
 * Color tokens are deprecated. Use useThemeColor() or useColorModeValue() hook instead.
 * @deprecated
 * @public
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default { ...(colors as any), ...tokens.color } as Color;
